export const TextColors = {
  darkGrey: '#3D4042',
  grey: '#838d96',
}